import { useRequest } from './useRequest';
import { UseGetPrincipalPreviewsRequests } from '../shared/types/main';

export const useGetPrincipalPreviewsRequests = () => {
  return useRequest<UseGetPrincipalPreviewsRequests>('/v1/surety/principals/previews', 'GET');
};
